<button
  *ngIf="icon"
  mat-icon-button
  [attr.data-cy]="dataCy ?? 'icon-button'"
  (click)="handleClick()"
  (mousedown)="preventDefault($event)"
  class="basic-button basic-icon {{ 'icon-' + color }} {{ 'icon-' + size }} {{
    'density-' + density 
  }}"
  [ngClass]="{ 'icon-disabled': disabled, 'icon-not-ripple': !hasRipple, 'label-icon': label }"
  [disableRipple]="disabled || !hasRipple"
  matTooltipClass="cm-tooltip typography__tooltip {{ tooltipClass }}"
  matTooltipShowDelay="1500"
  [matTooltipPosition]="tooltipPosition"
  [matTooltip]="tooltipMessage"
>
  <mat-icon class="material-icons-{{ iconMode }}"> {{ icon }} </mat-icon>
  <span class="btn-label" *ngIf="label">{{label | translate}}</span>
</button>
